import { Periods } from '@shared/utils/History/TFInfo';
import { HistoryMergerBasedByDay } from './HistoryMergerBasedByDay';
export class HistoryMergerDay extends HistoryMergerBasedByDay {
    constructor(inputParams) {
        super(inputParams);
    }
    GetDaysInPeriod(dateTime) {
        return this.GetCount();
    }
    IsStartPeriodDate(dateTime) {
        return true;
    }
    GetBasePeriod() {
        return Periods.DAY;
    }
}
